/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ActivityReadModel,
  CreateActivityCommentRequest,
  MutateActivityRequest,
  UpdateActivityCommentRequest,
} from "../models/index";
import {
  ActivityReadModelFromJSON,
  ActivityReadModelToJSON,
  CreateActivityCommentRequestFromJSON,
  CreateActivityCommentRequestToJSON,
  MutateActivityRequestFromJSON,
  MutateActivityRequestToJSON,
  UpdateActivityCommentRequestFromJSON,
  UpdateActivityCommentRequestToJSON,
} from "../models/index";

export interface CreateActivityRequest {
  mutateActivityRequest: MutateActivityRequest;
}

export interface CreateActivityCommentOperationRequest {
  createActivityCommentRequest: CreateActivityCommentRequest;
}

export interface CreateSubActivitiesRequest {
  activityId: string;
  mutateActivityRequest: Array<MutateActivityRequest>;
}

export interface GetByIdRequest {
  claimId: string;
}

export interface UpdateActivityRequest {
  mutateActivityRequest: MutateActivityRequest;
}

export interface UpdateActivityCommentOperationRequest {
  updateActivityCommentRequest: UpdateActivityCommentRequest;
}

/**
 *
 */
export class ActivitiesApi extends runtime.BaseAPI {
  /**
   */
  async createActivityRaw(
    requestParameters: CreateActivityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["mutateActivityRequest"] == null) {
      throw new runtime.RequiredError(
        "mutateActivityRequest",
        'Required parameter "mutateActivityRequest" was null or undefined when calling createActivity().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/activities/create-activity`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: MutateActivityRequestToJSON(
          requestParameters["mutateActivityRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createActivity(
    requestParameters: CreateActivityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createActivityRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createActivityCommentRaw(
    requestParameters: CreateActivityCommentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["createActivityCommentRequest"] == null) {
      throw new runtime.RequiredError(
        "createActivityCommentRequest",
        'Required parameter "createActivityCommentRequest" was null or undefined when calling createActivityComment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/activities/create-activity-comment`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateActivityCommentRequestToJSON(
          requestParameters["createActivityCommentRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createActivityComment(
    requestParameters: CreateActivityCommentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createActivityCommentRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createSubActivitiesRaw(
    requestParameters: CreateSubActivitiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["activityId"] == null) {
      throw new runtime.RequiredError(
        "activityId",
        'Required parameter "activityId" was null or undefined when calling createSubActivities().',
      );
    }

    if (requestParameters["mutateActivityRequest"] == null) {
      throw new runtime.RequiredError(
        "mutateActivityRequest",
        'Required parameter "mutateActivityRequest" was null or undefined when calling createSubActivities().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/activities/{activityId}/sub-activities`.replace(
          `{${"activityId"}}`,
          encodeURIComponent(String(requestParameters["activityId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters["mutateActivityRequest"]!.map(
          MutateActivityRequestToJSON,
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createSubActivities(
    requestParameters: CreateSubActivitiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createSubActivitiesRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getByIdRaw(
    requestParameters: GetByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ActivityReadModel>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling getById().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/activities/get-by-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ActivityReadModelFromJSON(jsonValue),
    );
  }

  /**
   */
  async getById(
    requestParameters: GetByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ActivityReadModel> {
    const response = await this.getByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async updateActivityRaw(
    requestParameters: UpdateActivityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["mutateActivityRequest"] == null) {
      throw new runtime.RequiredError(
        "mutateActivityRequest",
        'Required parameter "mutateActivityRequest" was null or undefined when calling updateActivity().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/activities/update-activity`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: MutateActivityRequestToJSON(
          requestParameters["mutateActivityRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateActivity(
    requestParameters: UpdateActivityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateActivityRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateActivityCommentRaw(
    requestParameters: UpdateActivityCommentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["updateActivityCommentRequest"] == null) {
      throw new runtime.RequiredError(
        "updateActivityCommentRequest",
        'Required parameter "updateActivityCommentRequest" was null or undefined when calling updateActivityComment().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/activities/update-activity-comment`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateActivityCommentRequestToJSON(
          requestParameters["updateActivityCommentRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateActivityComment(
    requestParameters: UpdateActivityCommentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateActivityCommentRaw(requestParameters, initOverrides);
  }
}
